import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AuditCheckout from "@/pages/AuditCheckout";
import AuditThankYou from "@/pages/AuditThankYou";
import Dashboard from "@/pages/Dashboard";
import StayInformed from "@/pages/StayInformed";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/audit/checkout" element={<AuditCheckout />} />
            <Route path="/audit/thank-you" element={<AuditThankYou />} />
            <Route path="/stay-informed" element={<StayInformed />} />
            <Route path="/enroll" element={<Navigate to="/" replace />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requirePaid={false}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
